import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import Strings from "src/shared/Strings";

const STATES = [
    "EARNED",
    "FULFILLED",
    "SENT",
    "REDEEMED",
    "FAILED",
    "CANCELED",
    "REVOKED",
    "FULFILL_FAILED",
];

function buildUrl(webhookId) {
    return `/api/v4/webhooks/reward/${webhookId}/filters/state`;
}

function getStates(stateModel) {
    const states = stateModel.get("states");
    return states && states[0];
}

const StateFilterModel = Backbone.Model.extend({
    initialize(attributes, options) {
        this.webhookId =
            options.webhookId || this.collection.rewardWebhookModel.id;
    },

    urlRoot() {
        return buildUrl(this.webhookId);
    },
});

const StateFilterCollection = Backbone.Collection.extend({
    model: StateFilterModel,

    url() {
        return buildUrl(this.rewardWebhookModel.id);
    },

    initialize(attributes, options) {
        this.rewardWebhookModel = options.rewardWebhookModel;
    },

    getFilterName() {
        return "state_filter";
    },

    fetch() {
        if (
            this.rewardWebhookModel.isNew() ||
            this.rewardWebhookModel.get("type") === "GENERIC"
        ) {
            const deferred = $.Deferred();
            return deferred.resolve([]);
        }

        return Backbone.Collection.prototype.fetch.call(this);
    },

    loadItems() {
        const self = this;
        const deferred = $.Deferred();

        $.when(this.fetch()).done(() => {
            const selectedStates = self.map(getStates);
            const allItems = _.map(STATES, (state) => ({
                id: state,
                value: Strings.capitalize(state),
                isSelected: _.contains(selectedStates, state),
            }));

            self.rewardWebhookModel.set(self.getFilterName(), selectedStates);
            deferred.resolve(allItems);
        });

        return deferred;
    },

    save() {
        const self = this;
        const deferred = $.Deferred();
        const states = this.rewardWebhookModel.get(this.getFilterName()) || [];
        const createPromises = this.getCreatePromises(states);
        const deletedPromises = this.getDeletePromises(states);
        const promises = _.union(createPromises, deletedPromises);

        $.when
            .apply($, promises)
            .done(() => {
                $.when(self.fetch()).always(deferred.resolve);
                deferred.resolve();
            })
            .fail(deferred.reject);

        return deferred;
    },

    getCreatePromises(states) {
        return _.difference(states, this.map(getStates)).map(
            this.createNewFilter.bind(this)
        );
    },

    getDeletePromises(states) {
        return this.filter((filter) => {
            const currentStates = filter.get("states");
            return !_.contains(states, currentStates && currentStates[0]);
        }).map((filter) => filter.destroy());
    },

    createNewFilter(state) {
        return new StateFilterModel(
            {
                states: [state],
            },
            { webhookId: this.rewardWebhookModel.id }
        ).save();
    },
});

StateFilterCollection.create = function (rewardWebhookModel) {
    return new StateFilterCollection(
        {},
        {
            rewardWebhookModel,
        }
    );
};

export default StateFilterCollection;
